"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Spinner = _interopRequireDefault(require("../shapes/Spinner"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var defaultNoDataText = 'Loading...';

var TableSpinner = function TableSpinner(_ref) {
  var loading = _ref.loading,
      loadingText = _ref.loadingText,
      data = _ref.data;
  return loading && _react["default"].createElement("div", {
    style: {
      position: 'absolute',
      left: 0,
      top: 48,
      // magic number; the height of table header
      bottom: data && data.length ? 83 : 0,
      // 83 is a magic number; bottom margin of the table + pagination height
      width: '100%',
      backgroundColor: 'rgba(255,255,255,0.8)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center'
    }
  }, _react["default"].createElement(_Spinner["default"], null), loadingText || defaultNoDataText);
};

TableSpinner.propTypes = {
  data: _propTypes["default"].array,
  // eslint-disable-line react/forbid-prop-types
  loading: _propTypes["default"].bool,
  loadingText: _propTypes["default"].node
};
var _default = TableSpinner;
exports["default"] = _default;